export default __webpack_public_path__ + "static/media/bg6.1e1cc55f.jpg";